const TableHeaders = ({ headers }) => {
	return (
		<tr>
			{headers.map((header) => (
				<th key={header}>{header}</th>
			))}
		</tr>
	);
};

export default TableHeaders;
